<div id="scrn">
  <div id="scrn-c">
    <div *ngIf="firstTime">
      <div class="message-heading">
        {{ locale.firstTimeTitleText }}
      </div>
      <div class="message-text">
        <div class="small-container">
          {{ locale.firstTimeSubtitleText }}<br />
          {{ locale.firstTimeSubtitleQuestionsText }}
        </div>
      </div>
      <button class="form-control btn" (click)="goToMain()">
        {{ locale.startButtonText }}
      </button>
      <br /><br />
      <a class="cancel_link" href="#" (click)="logout()">{{ locale.logoutButtonText }}</a>
    </div>

    <div *ngIf="!firstTime && questionsRemaining > 0">
      <div class="message-heading">{{ locale.titleText }} {{ this.currentUser.firstName }}!</div>

      <div *ngIf="multiQuestionsRemaining > 0; else preferences">
        <div *ngIf="multiQuestionsRemaining == 1">
          <div class="message-text">
            <div ngxBalanceText>
              {{ locale.remainingQuestionLabelText | stringFormat: [this.multiQuestionsRemaining] }}
            </div>
          </div>
        </div>

        <div *ngIf="multiQuestionsRemaining > 1">
          <div class="message-text">
            <div ngxBalanceText>
              {{ locale.remainingQuestionsLabelText | stringFormat: [this.multiQuestionsRemaining] }}
            </div>
          </div>
        </div>
      </div>

      <ng-template #preferences>
        <div class="message-text">
          <div ngxBalanceText>
            {{ locale.remainingPreferences }}
          </div>
        </div>
      </ng-template>

      <button class="form-control btn" (click)="goToMain()">
        {{ locale.continueButtonText }}
      </button>
      <br /><br />
      <a class="cancel_link" href="#" (click)="logout()">{{ locale.logoutButtonText }}</a>
    </div>
    <div *ngIf="!firstTime && questionsRemaining == 0">
      <div class="message-heading">{{ locale.titleText }}<br />{{ this.currentUser.firstName }}!</div>
      <div class="message-text message-text-welcome">
        <div class="inner-text message-text-center" ngxBalanceText>
          {{ locale.subtitleText }}
        </div>
        <div ngxBalanceText>
          <p class="inner-text">{{ locale.listHeading }}</p>
          <ul class="welcome-list">
            <li [innerHTML]="locale.list.first"></li>
            <li [innerHTML]="locale.list.second"></li>
            <li [innerHTML]="locale.list.third"></li>
            <li [innerHTML]="locale.list.fourth"></li>
          </ul>
        </div>
      </div>
      <button class="form-control btn" (click)="goToResults()">
        {{ locale.resultsButtonText }}
      </button>
      <br /><br />
      <a class="cancel_link" href="#" (click)="logout()">{{ locale.logoutButtonText }}</a>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/welcome/welcome.component.html